<template>
  <div class="terms-page">
    <!-- 右上角语言切换 -->
    <div class="terms-lang">
      <LangSwitcher @language-changed="onLanguageChanged" />
    </div>

    <!-- ===== 顶部标题区 ===== -->
    <!-- <section class="terms-header">
      <div class="terms-header-bg">
        <div class="terms-orb terms-orb-1"></div>
        <div class="terms-orb terms-orb-2"></div>
      </div>
      <div class="terms-header-content">
        <span class="section-badge">📜 法律文件</span>
        <h1 class="terms-title">Terms of <span class="highlight">Use</span></h1>
        <p class="terms-subtitle">Radiant Infrastructure Ltd</p>
        <p class="terms-desc">
          本协议最后更新于 2026 年 8 月 6 日<br />
          请仔细阅读以下条款和条件
        </p>
      </div>
    </section> -->

    <!-- ===== 主体：左侧锚点 + 右侧内容 ===== -->
    <section class="terms-body">
      <div class="terms-container">
        <!-- 左侧锚点导航 -->
        <aside class="terms-sidebar">
          <div class="sidebar-sticky">
            <div class="sidebar-title">📑 目录</div>
            <nav class="sidebar-nav">
              <a
                v-for="item in toc"
                :key="item.id"
                :href="`#${item.id}`"
                class="sidebar-link"
                :class="{ active: activeSection === item.id }"
                @click.prevent="scrollToSection(item.id)"
              >
                <span class="link-dot"></span>
                {{ item.label }}
              </a>
            </nav>
          </div>
        </aside>

        <!-- 右侧内容 -->
        <main class="terms-content">
          <!-- 1. 协议引言 -->
          <section
            v-for="i in 14"
            :id="`t${i}`"
            class="terms-section"
            :key="i"
          >
            <h2 class="section-title-text">{{ $t(`agreement.t${i}`) }}</h2>
            <div class="section-content" v-html="$t(`agreement.c${i}`)"></div>
          </section>
          <!-- 底部页脚 -->
          <!-- <div class="terms-footer">
            <p>© 2026 Radiant Infrastructure Ltd. All rights reserved.</p>
            <p class="footer-update">Last Updated: August 6, 2026</p>
          </div> -->
        </main>
      </div>
    </section>
  </div>
</template>

<script>
import LangSwitcher from "@/components/LangSwitcher.vue";

export default {
  name: "TermsPage",
  components: {
    LangSwitcher,
  },
  data() {
    return {
      activeSection: "introduction",
      toc: [
        { id: "t1", label: this.$t("agreement.t1") },
        { id: "t2", label: this.$t("agreement.t2") },
        { id: "t3", label: this.$t("agreement.t3") },
        { id: "t4", label: this.$t("agreement.t4") },
        { id: "t5", label: this.$t("agreement.t5") },
        { id: "t6", label: this.$t("agreement.t6") },
        { id: "t7", label: this.$t("agreement.t7") },
        { id: "t8", label: this.$t("agreement.t8") },
        { id: "t9", label: this.$t("agreement.t9") },
        { id: "t10", label: this.$t("agreement.t10") },
        { id: "t11", label: this.$t("agreement.t11") },
        { id: "t12", label: this.$t("agreement.t12") },
        { id: "t13", label: this.$t("agreement.t13") },
        { id: "t14", label: this.$t("agreement.t14") },
      ],
    };
  },
  methods: {
    // ===== 语言切换回调 =====
    onLanguageChanged(code) {
      this.$emit("language-changed", code);
    },

    scrollToSection(id) {
      this.activeSection = id;
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const top =
          element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
  },
  mounted() {
    // 滚动监听高亮 - 使用 scroll 事件更准确
    this.handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // 加上偏移量
      let current = this.toc[0]?.id || "";

      for (const item of this.toc) {
        const el = document.getElementById(item.id);
        if (el && el.offsetTop <= scrollPosition) {
          current = item.id;
        }
      }

      // 如果滚动到底部，标记最后一个
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 10
      ) {
        current = this.toc[this.toc.length - 1]?.id || current;
      }

      if (this.activeSection !== current) {
        this.activeSection = current;
      }
    };

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    // 初始化时执行一次
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  beforeDestroy() {
    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped>
/* ============================================================
   通用
   ============================================================ */
.terms-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #0a0e1a;
  color: #fff;
  overflow-x: clip;
}

/* ===== 右上角语言切换 ===== */
.terms-lang {
  position: fixed;
  top: 20px;
  right: 24px;
  z-index: 1000;
}

.section-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 12px;
}

.highlight {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.highlight-text {
  color: #00b4ff;
}

/* ============================================================
   顶部标题区
   ============================================================ */
.terms-header {
  padding: 80px 20px 60px;
  position: relative;
  overflow: hidden;
  text-align: center;
  background: linear-gradient(135deg, #080c18, #0f1a2e);
}

.terms-header-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.terms-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.12;
}

.terms-orb-1 {
  width: 500px;
  height: 500px;
  background: #00b4ff;
  top: -250px;
  left: -100px;
}

.terms-orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -200px;
  right: -80px;
}

.terms-header-content {
  position: relative;
  z-index: 1;
}

.terms-title {
  font-size: 56px;
  font-weight: 900;
  margin: 8px 0;
}

.terms-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 8px 0;
}

.terms-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.8;
  margin: 0;
}

/* ============================================================
   主体：左侧锚点 + 右侧内容
   ============================================================ */
.terms-body {
  padding: 40px 20px 80px;
  background: #0a0e1a;
}

.terms-container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  gap: 48px;
  align-items: flex-start;
}

/* ===== 左侧侧边栏 ===== */
.terms-sidebar {
  flex: 0 0 260px;
  position: sticky;
  top: 75px;
  align-self: flex-start;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.terms-sidebar::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

.sidebar-sticky {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px 16px;
}

.sidebar-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 16px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
}

.sidebar-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

.sidebar-link.active {
  color: #00b4ff;
  background: rgba(0, 180, 255, 0.06);
}

.sidebar-link.active .link-dot {
  background: #00b4ff;
  box-shadow: 0 0 12px rgba(0, 180, 255, 0.4);
}

.link-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.sidebar-link:hover .link-dot {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== 右侧内容 ===== */
.terms-content {
  flex: 1;
  min-width: 0;
}

.terms-section {
  margin-bottom: 48px;
  scroll-margin-top: 80px;
}

.section-title-text {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(0, 180, 255, 0.1);
}

.section-content {
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  font-size: 15px;
}

.section-content p {
  margin: 0 0 16px 0;
}

.section-content h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 28px 0 12px 0;
}

.section-content h3:first-of-type {
  margin-top: 0;
}

/* ===== 通用列表 ===== */
.terms-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
}

.terms-list li {
  position: relative;
  padding: 8px 0 8px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.terms-list li::before {
  content: "▸";
  position: absolute;
  left: 0;
  color: #00b4ff;
}

.terms-list li:last-child {
  border-bottom: none;
}

.terms-list li strong {
  color: #fff;
}

/* ===== 通知框 ===== */
.notice-box {
  display: flex;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 12px;
  background: rgba(0, 180, 255, 0.04);
  border: 1px solid rgba(0, 180, 255, 0.08);
  margin: 16px 0;
}

.notice-box.notice-warning {
  background: rgba(255, 215, 0, 0.04);
  border-color: rgba(255, 215, 0, 0.08);
}

.notice-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.notice-box strong {
  color: #fff;
}

/* ===== Definitions 网格 ===== */
.def-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.def-item {
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.def-item:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.def-term {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  color: #00b4ff;
  font-family: "SF Mono", "Courier New", monospace;
  margin-bottom: 6px;
}

.def-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  line-height: 1.7;
}

.def-link {
  color: #00b4ff;
  text-decoration: none;
}

.def-link:hover {
  text-decoration: underline;
}

/* ===== IP 网格 ===== */
.ip-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 12px;
}

.ip-card {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.ip-card:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.ip-icon {
  font-size: 28px;
  flex-shrink: 0;
}

.ip-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.ip-card p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== Payment 高亮 ===== */
.payment-highlight {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 12px;
}

.payment-item {
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  text-align: center;
}

.payment-label {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.payment-value {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

/* ===== Liability 卡片 ===== */
.liability-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.liability-item {
  display: flex;
  gap: 14px;
  padding: 18px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
}

.liability-icon {
  font-size: 28px;
  flex-shrink: 0;
}

.liability-item h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.liability-item p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== General 网格 ===== */
.general-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.general-item {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.general-item:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.general-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.general-item h4 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.general-item p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.5;
}

/* ===== 底部页脚 ===== */
.terms-footer {
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  text-align: center;
}

.terms-footer p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.2);
  margin: 4px 0;
}

.terms-footer .footer-update {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.12);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .terms-container {
    flex-direction: column;
  }

  .terms-sidebar {
    flex: unset;
    position: static;
    width: 100%;
  }

  .sidebar-sticky {
    padding: 16px 12px;
  }

  .sidebar-nav {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

  .sidebar-link {
    padding: 6px 14px;
    font-size: 13px;
  }

  .sidebar-link .link-dot {
    display: none;
  }

  .sidebar-title {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .ip-grid,
  .payment-highlight,
  .liability-card,
  .general-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .terms-title {
    font-size: 36px;
  }

  .terms-header {
    padding: 50px 16px 40px;
  }

  .section-title-text {
    font-size: 22px;
  }

  .terms-body {
    padding: 20px 16px 60px;
  }

  .terms-section {
    margin-bottom: 32px;
  }

  .def-item {
    padding: 12px 16px;
  }

  .payment-highlight {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .terms-title {
    font-size: 28px;
  }

  .section-title-text {
    font-size: 20px;
  }

  .sidebar-link {
    font-size: 12px;
    padding: 4px 10px;
  }

  .ip-card,
  .liability-item,
  .general-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .notice-box {
    flex-direction: column;
    align-items: flex-start;
  }
}

.terms-content >>> p {
  margin: 0;
  padding: 0 !important;
}
.terms-content >>> strong {
  font-weight: bold;
  font-size: 17px;
  color: #fff;
}
</style>
